import React from 'react';
import { Button, Flex, Text } from '@chakra-ui/react';
import { AsyncSelector } from '../../../components/AsyncSelector';
import { TerminalFiltersQueryParams } from '../hooks/useTerminalsFilters';
import { RoleValidator } from '../../../components/RoleValidator';
import { SearchFilter } from '../../../components/SearchFilter';
import { FiTrash } from 'react-icons/fi';
import { Role } from '../../../domain/Role';

interface TerminalFiltersProps {
  onUpdateFilters: (key: keyof TerminalFiltersQueryParams, value?: string | string[]) => void;
  queryParams?: TerminalFiltersQueryParams;
  resetFilters: () => void;
}

export const TerminalFilters = ({ onUpdateFilters, queryParams, resetFilters }: TerminalFiltersProps) => {
  return (
    <Flex flexWrap="wrap" alignItems="center" marginLeft="xl" alignContent="center" marginBottom="xl" justifyContent="start">
      <Text fontWeight="bold" fontSize="m" >Filtros:</Text>

      <RoleValidator allowedRoles={[Role.auditor]}>
        <AsyncSelector<{ id: string; business_name: string }>
          value={queryParams?.idMerchant}
          isMulti={true}
          handleChange={(value) => onUpdateFilters('idMerchant', value?.map((item) => item.id) || [])}
          url="/terminals-view/filters"
          labelProperty="business_name"
          noSelectedLabel="Todos los comercios"
          idProperty="id"
          margin="l"
        />
      </RoleValidator>

      <SearchFilter
        value={queryParams?.serialNumber}
        handleChange={(value) => onUpdateFilters('serialNumber', value)}
        placeholder="Número de serie"
        width="12em"
        debounceDelay={500}
        inputType="number"
        marginLeft="l"
      />

      <RoleValidator allowedRoles={[Role.branch_owner]}>
        <Button
          marginLeft="auto"
          color="primary.800"
          variant="ghost"
          onClick={resetFilters}>
          <FiTrash fontSize="1.2em" />
          <Text marginLeft="l">Limpiar filtros</Text>
        </Button>
      </RoleValidator>
    </Flex>
  );
};
